exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?{\"sourceMap\":false,\"importLoaders\":1}!../node_modules/postcss-loader/lib/index.js??postcss!bootstrap/dist/css/bootstrap.css"), "");

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n\n.badgeContainer {\n    margin-top: 15px;\n    margin-bottom: 10px;\n    max-width: 700px;\n}\n\n.skillBadge {\n    padding: 5px;\n    padding-right: 12px;\n    border-radius: 10px;\n    background-color: rgba(32, 187, 32, 0.918);\n    color: #fff;\n    display: inline-block;\n    margin-bottom: 10px;\n}\n\n.skillPlus {\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 5px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/masonpimentel/Repos/mason-blog/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/masonpimentel/Repos/mason-blog/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/Users/masonpimentel/Repos/mason-blog/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles